import { LocaleType } from './Locale';

const theLocale: LocaleType = {
    locale: 'ph',
    conver: 'en-PH',
    alia: 'en',
    region: 'Philippines',
    regionText: 'Philippines',
    language: 'English',
    languageText: 'English',
    appId: 25,
    acceptLanguage: 'en-PH,en;q=0.9',
};
export default theLocale;
